import React, { useState, useEffect } from "react";
import NavBarTop from '../../NavBar_Top/NavBar_Top';
import Carrossel from '../../Carrossel/Carrossel';
import Carrossel_mini from '../../Carrossel_mini/Carrossel_mini';
import Rodape from '../../Rodape/Rodape';
import { ToastContainer, toast } from 'react-toastify';
import { BrowserView, MobileView } from 'react-device-detect';
import api from '../../../services/api';
// import { initGA, logPageView } from "../../../services/analytics";
// import { useLocation } from "react-router-dom";

function Home() {
  const [retornoApiSimultaneos, setRetornoApiSimultaneos] = useState([]);
  const [freteError, setFreteError] = useState("");
  const [posicao, setPosicao] = useState([]);

  const toastErroApiNaoResponde = () => toast.error("Ops, Alguma Coisa Errada com Nosso Servidor!",
    { position: toast.POSITION.TOP_CENTER, theme: "colored" });

  useEffect(() => {
    BuscarItensVendidosSimultaneamente(0, 12);
  }, []);

  function BuscarItensVendidosSimultaneamente(_codigo, _limite) {
    //console.log("TEStE --A", `Produtos/vendidosJuntos/${_codigo}/${_limite}`);
    api.get(`Produtos/vendidosJuntos/${_codigo}/${_limite}`).then((response) => {
      if (response == null || response?.data == null) {
        setRetornoApiSimultaneos([]);
        // console.log("TEStE A");
      }
      else {
        // console.log("TEStE B", response.data);
        setRetornoApiSimultaneos(response.data);
      }

    }).catch((e) => {
      if (e == "Error: Network Error") {
        toastErroApiNaoResponde();
        setFreteError("Ops, Nosso Servidor Não Respondeu...");
        // console.log("TEStE C");
        return null;
      }
    })
  }

  // console.log("TEStE D");

  // const location = useLocation();

  // useEffect(() => {
  //   initGA();
  // }, []);

  // useEffect(() => {
  //   logPageView();
  // }, [location]);


  return (
    <div>
      <BrowserView>
        <NavBarTop />
        <Carrossel />
        <Carrossel_mini props={retornoApiSimultaneos} espacamento={100} itensPorPaginaView={8} />
        <Rodape />
      </BrowserView>

      <MobileView>
        <NavBarTop />
        <Carrossel />
        <Carrossel_mini props={retornoApiSimultaneos} espacamento={100} itensPorPaginaView={3}/>
        <Rodape />
      </MobileView>



      <ToastContainer />
    </div>
  )
}

export default Home